import { Component } from '@angular/core';
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-info-procedimientos',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './info-procedimientos.component.html',
  styleUrl: './info-procedimientos.component.css'
})
export class InfoProcedimientosComponent {
  listItems = [
    {
      texto: "Exámenes de laboratorio",
    },
    {
      texto: "Resonancia magnética"
    },
    {
      texto: "Rayos X"
    },
    {
      texto: "Espirometría"
    },
    {
      texto: "Especialidades Médicas"
    },
    {
      texto: "Audiometría"
    },
    {
      texto: "Electrocardiograma"
    }

  ]

}
